<template>
    <div class="row justify-content-center">
        <div class="col-12 mx-auto">
            <p class="fts-18 pl-3 h-emphasis mb-0" style="font-weight: 900;">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trophy-fill mr-2" viewBox="0 0 16 16">
                    <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5c0 .538-.012 1.05-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33.076 33.076 0 0 1 2.5.5zm.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935zm10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935z"/>
                </svg>
                Le top 20 de vos positions sur l'ensemble de vos portefeuilles
            </p>
        </div>
        <div class="col-12 mx-auto py-3">
            <table class="mx-auto" style="width:100%;">
                <thead>
                    <tr>
                        <th class="pl-3 text-left">
                            <label for="checkbox" class="fts-14 font-weight-bold" style="color: rgba(255, 255, 255, .87)">Cacher les liquidités</label>
                            <input type="checkbox"
                                style="font-size: 14px; vertical-align: middle;"
                                id = "checkbox"
                                v-model="filterstatus"
                                @change="onFilterStatusChange()">
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="col-12 mx-auto pt-0 mb-5 pb-3">
            <table class="myfotable-dark">
                <colgroup>
                    <col style="width: 15%;">
                    <col style="width: 10%;">
                    <col style="width: 10%;">
                    <col style="width: 10%;">
                    <col style="width: 10%;">
                    <col style="width: 10%;">
                    <col style="width: 10%;">
                </colgroup>
                <thead>
                    <tr style="background-color: rgba(38, 42, 62, .05);">
                        <th class="py-3 text-left pl-3">Position</th>
                        <th>Poids (%)</th>
                        <th>Classe d'actifs</th>
                        <th>Secteur</th>
                        <th>Pays</th>
                        <th>Devise</th>
                        <th>Provenance</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(comparison, index) in customs" :key="index">
                        <td class="py-3 text-left">
                            <div v-if="comparison.weight_total > 10">
                                <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                    <p class="mb-0 pl-2 font-weight-bold" style="color: rgb(187, 134, 252);">{{ comparison.sec.name }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style="margin-bottom: 4px;" fill="#CF6679" class="bi bi-exclamation-triangle-fill ml-1" viewBox="0 0 16 16">
                                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                        </svg>
                                    </p>
                                </div>
                                <div v-else>
                                    <p class="mb-0 pl-2 font-weight-bold" style="color: rgb(187, 134, 252);">{{ comparison.sec.name }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" style="margin-bottom: 4px;" fill="#CF6679" class="bi bi-exclamation-triangle-fill ml-1" viewBox="0 0 16 16">
                                            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
                                        </svg>
                                    </p>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                    <p class="mb-0 pl-2 font-weight-bold" style="color: rgb(187, 134, 252);">{{ comparison.sec.name }}</p>
                                </div>
                                <div v-else>
                                    <p class="mb-0 pl-2 font-weight-bold" style="color: rgb(187, 134, 252);">{{ comparison.sec.name }}</p>
                                </div>
                            </div>
                            <div>
                                <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                    <p class="mb-0 pl-2">ISIN : <span style="color: rgb(187, 134, 252); background-color: rgba(187, 134, 252, .1); padding: 2px; border-radius: 5px;">{{ comparison.sec.isin }}</span></p>
                                </div>
                                <div v-else>
                                    <p class="mb-0 pl-2">ISIN : <span style="color: rgb(187, 134, 252); background-color: rgba(187, 134, 252, .1); padding: 2px; border-radius: 5px;">{{ comparison.sec.isin }}</span></p>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                {{ Math.round(comparison.weight_total*100)/100 }}
                            </div>
                            <div v-else>
                                {{ Math.round(comparison.weight_total*100)/100 }}
                            </div>
                        </td>
                        <td v-if="comparison.sec.asset_class!=null">
                            <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                {{ comparison.sec.asset_class.name_french }}
                            </div>
                            <div v-else>
                                {{ comparison.sec.asset_class.name_french }}
                            </div>
                        </td>
                        <td v-else>
                        </td>
                        <td v-if="comparison.sec.sector!=null">
                            <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                {{ comparison.sec.sector.name_french }}
                            </div>
                            <div v-else>
                                {{ comparison.sec.sector.name_french }}
                            </div>
                        </td>
                        <td v-else>
                        </td>
                        <td v-if="comparison.sec.country!=null">
                            <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                {{ comparison.sec.country.name }}
                            </div>
                            <div v-else>
                                {{ comparison.sec.country.name }}
                            </div>
                        </td>
                        <td v-else>
                        </td>
                        <td v-if="comparison.sec.currency!=null">
                            <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                {{ comparison.sec.currency.code }}
                            </div>
                            <div v-else>
                                {{ comparison.sec.currency.code }}
                            </div>
                        </td>
                        <td v-else>
                        </td>
                        <td v-if="comparison.weight_etf != 0" class="text-center">
                            <div v-if="comparison.sec.name == 'myfo rocks'" class='blurry'>
                                <p class="light-white-02">Passez à la version premium pour accéder aux détails de vos positions</p>
                                <button class="btn-transparncy m-3"><a :href="'/app/home/payment/portal'">Upgrader</a></button>
                            </div>
                            <div v-else>
                                <button class="btn-alt-2 fts-12" v-b-modal="modalId(comparison.sec.isin+' '+comparison.weight_total)">
                                    Provenance
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-plus-circle ml-1" style= "margin-bottom: 2px;" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                </button>
                                <b-modal
                                    title="La décomposition de votre allocation"
                                    class="modal fade alt-list" :id="'modal' + comparison.sec.isin+' '+comparison.weight_total"
                                    tabindex="-1"
                                    role="dialog"
                                    size="xl"
                                    aria-labelledby="alternatives"
                                    aria-hidden="true"
                                    :header-bg-variant="headerBgVariant"
                                    :header-text-variant="headerTextVariant"
                                    :body-bg-variant="bodyBgVariant"
                                    :body-text-variant="bodyTextVariant"
                                    :footer-bg-variant="footerBgVariant"
                                    :footer-text-variant="footerTextVariant"
                                    ok-only
                                    >
                                    <div>
                                        <div>
                                            <p class="fts-18 font-weight-bold mb-2 h-emphasis">Allocation directe : {{ Math.round(comparison.weight_direct*100)/100 }} %</p>
                                        </div>
                                        <div>
                                            <p class="fts-18 mb-4 font-weight-bold" style="color: #BB86FC;">Autre provenance : {{ Math.round(comparison.weight_etf*100)/100 }} %</p>
                                        </div>
                                        <table class="myfotable-dark">
                                            <colgroup>
                                                <col style="width: 33.33%;">
                                                <col style="width: 33.33%;">
                                                <col style="width: 33.33%;">
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th style="text-align: left;">Fond</th>
                                                    <th>ISIN</th>
                                                    <th>Poids</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(etf, i) in comparison.etf" :key="i">
                                                    <td style="font-weight: bold; color: rgb(187, 134, 252); text-align: left;">{{ etf.security.name }}</td>
                                                    <td>{{ etf.security.isin }}</td>
                                                    <td style="font-weight: bold;">{{ Math.round(etf.weight*100)/100 }} %</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-modal>
                            </div>
                        </td>
                        <td v-else class="text-center">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'comparisons',
            'token',
            'route',
        ],

        data() {
            return {
                customs:[],
                filtername:"",
                filterstatus:"",
                filtersector:"",
                show: false,
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            this.comparisons.forEach(comparison =>
            {
                this.customs.push(comparison)
            });
        },


        methods: {
            onFilterNameChange(){
                this.customs=[];
                this.comparisons.forEach(comparison =>
                {
                    if (comparison.name.toLowerCase().includes(this.filtername.toLowerCase()))
                    {
                        this.customs.push(comparison);
                    }
                });

            },
            onFilterStatusChange(){
                this.customs=[];
                if (this.filterstatus)
                {
                    this.comparisons.forEach(comparison =>
                    {
                        if (comparison.sec.asset_class.name != "cash")
                        {
                            this.customs.push(comparison);
                        }
                    });

                }
                else
                {
                    this.comparisons.forEach(comparison =>
                    {
                        this.customs.push(comparison);
                    })
                }
            },
            onFilterSectorChange(){
                this.customs=[];
                this.comparisons.forEach(comparison =>
                {
                    if (comparison.sector.toLowerCase().includes(this.filtersector.toLowerCase()))
                    {
                        this.customs.push(comparison);
                    }
                });

            },
            modalId(i) {
            return 'modal' + i;
            },
    }
}

</script>